export const CATEGORIES_COLLECTION = 'categories';
export const SUBCATEGORIES_COLLECTION = 'subcategories';
export const CUSTOM_FIELD_DEFINITIONS_COLLECTION = 'customFieldDefinitions';
export const ITEMS_COLLECTION = 'items';
